import { api } from '@rd-web-markets/shared/dist/services/service';
const dataLicencesCostsService = {
  get: data_licences_cost => api.get(`/claims/${data_licences_cost.claim_id}/data_licences_costs/${data_licences_cost.id}`),
  update: data_licences_cost => api.update(`/claims/${data_licences_cost.claim_id}/data_licences_costs/${data_licences_cost.id}`, data_licences_cost),
  all: claimId => api.get(`/claims/${claimId}/data_licences_costs`),
  delete: data_licences_cost => api.delete(`/claims/${data_licences_cost.claim_id}/data_licences_costs/${data_licences_cost.id}`),
  create: data_licences_cost => api.create(`/claims/${data_licences_cost.claim_id}/data_licences_costs`, data_licences_cost)
};
export default dataLicencesCostsService;